import { useMemo } from 'react';
import {
    FieldOptionDTO,
    ConditionOperator,
    ConditionField,
    FieldOptionDTOFieldTypeEnum
} from "../../../../../../../../../api/generated";
import { UpdateConditionRequestUI } from "../../../../toolSettingsSlice";
import { SelectOption } from "../../../../../../../../elements/select/SelectDropdown";

export const useConditionState = (
    condition: UpdateConditionRequestUI,
    fieldOptions: FieldOptionDTO[]
) => {
    const fieldOptionsSelect: SelectOption<ConditionField>[] = useMemo(() => {
        return fieldOptions.map(option => ({
            label: option.title || option.field || '',
            value: option.field as ConditionField
        }));
    }, [fieldOptions]);

    const selectedFieldOption = useMemo(() => {
        return fieldOptions.find(opt => opt.field === condition.conditionField);
    }, [fieldOptions, condition.conditionField]);

    const selectedOperator = useMemo(() => {
        return selectedFieldOption?.availableOperators?.find(
            op => op.value === condition.operator
        );
    }, [selectedFieldOption, condition.operator]);

    const operatorOptions: SelectOption<string>[] = useMemo(() => {
        if (!selectedFieldOption?.availableOperators) {
            return [];
        }
        return selectedFieldOption.availableOperators.map(op => ({
            label: op.title || op.value || '',
            value: op.value || ''
        }));
    }, [selectedFieldOption]);

    const requiresInput = useMemo(() => {
        return selectedOperator?.requireInputField === true;
    }, [selectedOperator]);

    const requiresMultiValue = useMemo(() => {
        return selectedOperator?.requiredMultiValue === true;
    }, [selectedOperator]);

    const isEnumField = useMemo(() => {
        return selectedFieldOption?.fieldType === FieldOptionDTOFieldTypeEnum.EnumValue;
    }, [selectedFieldOption]);

    const isNumericField = useMemo(() => {
        return selectedFieldOption?.fieldType === FieldOptionDTOFieldTypeEnum.Number;
    }, [selectedFieldOption]);

    const isRegexOperator = useMemo(() => {
        return condition.operator === ConditionOperator.Match || 
               condition.operator === ConditionOperator.NotMatch;
    }, [condition.operator]);

    const enumValueOptions: SelectOption<string>[] = useMemo(() => {
        if (!isEnumField || !selectedFieldOption?.enumValues) {
            return [];
        }
        return selectedFieldOption.enumValues.map(ev => ({
            label: ev.label || ev.value || '',
            value: ev.value || ''
        }));
    }, [isEnumField, selectedFieldOption]);

    return {
        fieldOptionsSelect,
        selectedFieldOption,
        selectedOperator,
        operatorOptions,
        requiresInput,
        requiresMultiValue,
        isEnumField,
        isNumericField,
        isRegexOperator,
        enumValueOptions
    };
};

